import { makeStyles } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";

export const useStyles = makeStyles(({ palette, spacing }) => ({
  bubbleContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    marginTop: "12px",
    marginBottom: "12px",
  },
  bubbleMessageContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  bubbleContainerLeft: {
    justifyContent: "start",
  },
  bubbleContainerRight: {
    justifyContent: "end",
  },
  bubble: {
    maxWidth: "65%",
    padding: "24px",
    borderRadius: spacing(1),
    border: "1px",
    gap: "24px",
    whiteSpace: "pre-wrap",
    lineBreak: "anywhere",
  },
  bubbleBlue: {
    color: palette.contrastText.main,
    marginRight: "24px",
    background: palette.secondary.main,
  },
  bubbleWhite: {
    marginLeft: "24px",
    background: palette.otherElementsBackground.main,
    border: `1px solid ${palette.separator.main}`,
    color: palette.contrastText.main,
  },
  actionButtons: {
    display: "flex",
    flexDirection: "row",
    marginRight: spacing(1),
  },
  nameRight: {
    display: "flex",
    flexDirection: "row-reverse",
    textAlign: "right",
  },
  nameLeft: {
    display: "flex",
    flexDirection: "row",
    textAlign: "left",
  },
  fileRight: {
    display: "flex",
    maxWidth: "100%",
    justifyContent: "end",
    marginRight: "12px",
  },
  fileLeft: {
    display: "flex",
    maxWidth: "100%",
    justifyContent: "start",
    marginLeft: "12px",
  },
  timeRight: {
    display: "flex",
    width: "100%",
    justifyContent: "flex-end",
    marginTop: spacing(1),
  },
  timeLeft: {
    display: "flex",
    width: "100%",
    justifyContent: "flex-start",
    marginTop: spacing(1),
  },
  name: {
    fontSize: "14px",
    fontWeight: 500,
    color: palette.contrastText.main,
  },
  nameLink: {
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: 500,
    "&:hover": {
      textDecoration: "underline",
    },
  },
  deletedText: {
    color: grey[600],
  },
  subName: {
    fontSize: "12px",
    color: grey[500],
  },
  replayContainer: {
    width: "100%",
    marginBottom: "8px",
    border: "1px solid rgba(224, 224, 224, 1)",
    borderRadius: "8px",
    padding: "8px",
    position: "relative",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
  },
  replayText: {
    marginLeft: "15px",
    flexGrow: 1,
  },
}));
